// Professional notice: trigger five seconds after the first successful add to cart, remembered for 365 days after acknowledgement.
document.addEventListener('DOMContentLoaded', () => {
  const popin = document.querySelector('.js-popin');
  const confirm = popin?.querySelector('.js-popin-close');
  if (!popin || !confirm) return;

  const ACK_COOKIE = 'SYM_POPIN';
  const PENDING_COOKIE = 'SYM_POPIN_PENDING';
  const DELAY_MS = 5000;

  let acknowledged = false;
  let timer = null;
  let previousFocus;

  const readCookie = (name) => {
    try {
      const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) {
      return '';
    }
  };

  const hasAcknowledged = () => {
    if (acknowledged) return true;
    return readCookie(ACK_COOKIE) === '1';
  };

  const clearPending = () => {
    try {
      document.cookie = `${PENDING_COOKIE}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax`;
    } catch (_) {}
  };

  const storePending = (timestamp) => {
    try {
      document.cookie = `${PENDING_COOKIE}=${encodeURIComponent(String(timestamp))};path=/;SameSite=Lax`;
    } catch (_) {}
  };

  const openPopin = () => {
    timer = null;
    if (hasAcknowledged() || popin.open) {
      if (hasAcknowledged()) clearPending();
      return;
    }

    previousFocus = document.activeElement;
    if (typeof popin.showModal === 'function') popin.showModal();
    else popin.setAttribute('open', '');
    popin.classList.add('--opened');
    document.body.classList.add('ux-pro-notice-open');
    confirm.focus({ preventScroll: true });
  };

  const scheduleFrom = (timestamp) => {
    if (hasAcknowledged() || popin.open || timer) return;
    const remaining = Math.max(0, DELAY_MS - Math.max(0, Date.now() - timestamp));
    timer = window.setTimeout(openPopin, remaining);
  };

  const startAfterSuccessfulAdd = () => {
    if (hasAcknowledged()) return;

    const existing = Number(readCookie(PENDING_COOKIE));
    const timestamp = Number.isFinite(existing) && existing > 0 ? existing : Date.now();

    if (!(Number.isFinite(existing) && existing > 0)) storePending(timestamp);
    scheduleFrom(timestamp);
  };

  if (!hasAcknowledged()) {
    const pending = Number(readCookie(PENDING_COOKIE));
    if (Number.isFinite(pending) && pending > 0) scheduleFrom(pending);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const productFormAdd = event?.source === 'product-form';
        const cartRecommendationAdd = event?.source === 'cart-items'
          && event?.cartData
          && !Object.prototype.hasOwnProperty.call(event.cartData, 'item_count')
          && (Object.prototype.hasOwnProperty.call(event.cartData, 'variant_id') || Object.prototype.hasOwnProperty.call(event.cartData, 'id'));
        if (productFormAdd || cartRecommendationAdd) startAfterSuccessfulAdd();
      });
    }
  } else {
    clearPending();
  }

  popin.addEventListener('cancel', (event) => event.preventDefault());
  popin.addEventListener('keyup', (event) => event.stopPropagation());

  confirm.addEventListener('click', () => {
    acknowledged = true;
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }

    const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    try {
      document.cookie = `${ACK_COOKIE}=1;expires=${expires};path=/;SameSite=Lax`;
    } catch (_) {}
    clearPending();

    popin.classList.remove('--opened');
    if (typeof popin.close === 'function') popin.close();
    else popin.removeAttribute('open');
    document.body.classList.remove('ux-pro-notice-open');

    const drawer = document.querySelector('cart-drawer.active .drawer__inner');
    if (drawer && typeof trapFocus === 'function') trapFocus(drawer, drawer);
    else if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
});
